<template>
  <div class="address-edit-container --claim">
    <div class="mask"></div>
    <el-form ref="addressForm" class="address-edit-form" :model="form" :rules="rules">
      <div class="form-group">
        <div class="group__title">认领案例</div>
        <div class="group__items">
          <el-form-item prop="mold_ids" label="选择分类" class="checkbox-item">
            <el-checkbox-group v-model="form.mold_ids" v-loading="loading.page">
              <template v-if="moldChildren">
                <el-checkbox
                  v-for="child in moldChildren"
                  :key="child.id"
                  :label="child.id"
                  name="mold_ids"
                  >{{ child.name }}</el-checkbox
                >
              </template>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="group__items">
          <el-form-item prop="content" class="textarea-item">
            <el-input type="textarea" placeholder="认领理由" v-model="form.content"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="form-group">
        <el-form-item class="item__bts">
          <el-button class="bt__item bt__cancel" @click="onCancel" :disabled="loading.submit"
            >取消</el-button
          >
          <el-button class="bt__item bt__submit" @click="onSubmit" :loading="loading.submit"
            >认领</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { molds } from '@/api/common';

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
    moldId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const checkSize = (rule, value, callback) => {
      if (value.length > rule.maxSize) {
        callback(new Error('最多选择三个分类'));
      }
      callback();
    };
    return {
      form: {
        id: this.id,
        type: this.type,
        mold_ids: [],
        content: '',
      },
      rules: {
        mold_ids: [
          {
            required: true,
            message: '请选择至少一个分类',
            trigger: 'change',
          },
          {
            maxSize: 3,
            validator: checkSize,
            trigger: 'change',
          },
        ],
        content: [
          {
            required: true,
            message: '请填写认领理由',
            trigger: 'change',
          },
        ],
      },
      loading: {
        submit: false,
        page: true,
      },
      moldChildren: null,
    };
  },
  async created() {
    this.loading.page = true;
    const res = await molds(this.moldId);
    this.moldChildren = res.data.list;
    this.loading.page = false;
  },
  methods: {
    onSubmit() {
      const that = this;
      that.$refs.addressForm.validate((valid) => {
        if (valid) {
          that.loading.submit = true;
          that.$http
            .post('html/caseller/caseClaim', {
              id: that.form.id,
              type: that.form.type,
              mold_ids: that.form.mold_ids,
              content: that.form.content,
            })
            .then(() => {
              that.$message({
                type: 'success',
                message: '认领成功，等待后台审核',
              });
              that.onCancel();
            })
            .finally(() => {
              that.loading.submit = false;
            });
        }
      });
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style></style>
